var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlert = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0026 2.50488C7.2069 2.50488 2.50781 7.20566 2.50781 12.9997C2.50781 18.7971 7.2069 23.4945 13.0026 23.4945C18.7983 23.4945 23.4974 18.7971 23.4974 12.9997C23.4974 7.20566 18.7983 2.50488 13.0026 2.50488ZM13.0026 7.15983C13.9842 7.15983 14.7799 7.95557 14.7799 8.93717C14.7799 9.91878 13.9842 10.7145 13.0026 10.7145C12.021 10.7145 11.2253 9.91878 11.2253 8.93717C11.2253 7.95557 12.021 7.15983 13.0026 7.15983ZM14.8646 18.4163C15.145 18.4163 15.3724 18.189 15.3724 17.9085V16.8929C15.3724 16.6125 15.145 16.3851 14.8646 16.3851H14.3568V12.1533C14.3568 11.8729 14.1294 11.6455 13.849 11.6455H11.1406C10.8602 11.6455 10.6328 11.8729 10.6328 12.1533V13.1689C10.6328 13.4494 10.8602 13.6768 11.1406 13.6768H11.6484V16.3851H11.1406C10.8602 16.3851 10.6328 16.6125 10.6328 16.8929V17.9085C10.6328 18.189 10.8602 18.4163 11.1406 18.4163H14.8646Z",
    fill: "#2E73DC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11135_12312",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 22,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0026 2.50488C7.2069 2.50488 2.50781 7.20566 2.50781 12.9997C2.50781 18.7971 7.2069 23.4945 13.0026 23.4945C18.7983 23.4945 23.4974 18.7971 23.4974 12.9997C23.4974 7.20566 18.7983 2.50488 13.0026 2.50488ZM13.0026 7.15983C13.9842 7.15983 14.7799 7.95557 14.7799 8.93717C14.7799 9.91878 13.9842 10.7145 13.0026 10.7145C12.021 10.7145 11.2253 9.91878 11.2253 8.93717C11.2253 7.95557 12.021 7.15983 13.0026 7.15983ZM14.8646 18.4163C15.145 18.4163 15.3724 18.189 15.3724 17.9085V16.8929C15.3724 16.6125 15.145 16.3851 14.8646 16.3851H14.3568V12.1533C14.3568 11.8729 14.1294 11.6455 13.849 11.6455H11.1406C10.8602 11.6455 10.6328 11.8729 10.6328 12.1533V13.1689C10.6328 13.4494 10.8602 13.6768 11.1406 13.6768H11.6484V16.3851H11.1406C10.8602 16.3851 10.6328 16.6125 10.6328 16.8929V17.9085C10.6328 18.189 10.8602 18.4163 11.1406 18.4163H14.8646Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11135_12312)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlert);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alert.ecdcab54c2421ce483e467052691026f.svg";